import { render, staticRenderFns } from "./EnquireCards.vue?vue&type=template&id=312090a4&scoped=true"
import script from "./EnquireCards.vue?vue&type=script&lang=ts"
export * from "./EnquireCards.vue?vue&type=script&lang=ts"
import style0 from "./EnquireCards.vue?vue&type=style&index=0&id=312090a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312090a4",
  null
  
)

export default component.exports